module.exports = __webpack_public_path__ + "media/country_flags/cw-a4baf6a6.png";